// 统一下载工具：通过创建 a 标签触发浏览器下载

export function downloadByUrl(url, filename) {
  const a = document.createElement('a')
  a.href = url
  // 不离开当前页面：在新标签页触发下载（部分浏览器会直接下载，不打开页面）
  a.target = '_blank'
  a.rel = 'noopener noreferrer'
  if (filename) a.download = filename
  a.style.display = 'none'
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}

export function buildQuery(params = {}) {
  const sp = new URLSearchParams()
  Object.keys(params).forEach(k => {
    const v = params[k]
    if (v === undefined || v === null || v === '') return
    sp.append(k, v)
  })
  const qs = sp.toString()
  return qs ? `?${qs}` : ''
}

